import axiosInstance from '../axiosInterceptor/axiosInstance'

const getClubTeams = async (orgId, clubId) => {
  const url =`v1/orgs/${orgId}/teams?clubId=${clubId}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getClubTeams
